import util from '../util/util';
export default {
    // 轮播图数据
    section1: [
        {
            // 图片地址
            link: util.get_img('index_banner_1.png?1'),
            // 标题
            title: '一站式移动广告服务',
            // 描述
            description: '网易有道旗下品质内容广告平台',
            // 按钮文案
            btn: '申请合作',
            cb: function(ctx) {
                ctx.bind_toggle_form('cooperation', 'banner');
            }
        },
        {
            // 图片地址
            link: util.get_img('index_banner_2.png?2'),
            // 标题
            title: '有道智选官方视频',
            // 描述
            description: '点击下方按钮立即观看',
            // 按钮文案
            btn: '点击播放',
            cb: function(ctx) {
                window._hmt && window._hmt.push(['_trackEvent', 'ctaTrigger', `index_banner`, 'video']);
                ctx.video_url = 'https://download.ydstatic.com/ead/%E6%9C%89%E9%81%93%E6%99%BA%E9%80%89%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%911min.mp4';
            }
        },
        {
            // 图片地址
            link: util.get_img('index_banner_3.png'),
            // 标题
            title: '专访网易有道运营总监',
            // 描述
            description: '从印度教育市场切入，网易有道如何做海外推广与变现',
            // 按钮文案
            btn: '阅读文章',
            cb: function(ctx) {
                window._hmt && window._hmt.push(['_trackEvent', 'ctaTrigger', `index_banner`, 'article']);
                ctx.$router.push({
                    path: `/news_content/1861847`
                });
            }
        }
    ],
    // 平台优势块数据
    section2: {
        // 模块名称
        name: '平台优势',
        data: [
            {
                // 图片地址
                link: util.get_img('ic_advantages_media.png'),
                // 标题
                title: '甄选流量',
                // 描述
                description: '以网易独家资源和有道媒体矩阵为核心，甄选海内外品质流量',
                route: 'flow'
            },
            {
                // 图片地址
                link: util.get_img('ic_advantages_AI.png'),
                // 标题
                title: 'AI赋能',
                // 描述
                description: '传承网易有道多年技术经验和云端产品的智能基因，AI赋能智慧决策',
                route: 'ai'
            },
            {
                // 图片地址
                link: util.get_img('ic_advantages_content.png'),
                // 标题
                title: '内容场景',
                // 描述
                description: '真实还原用户使用场景，为媒体量身定制内容广告形式',
                route: 'content'
            },
            {
                // 图片地址
                link: util.get_img('ic_advantages_service.png'),
                // 标题
                title: '多维服务',
                // 描述
                description: '围绕您的KPI定制数字营销策略，实现全方位推广服务',
                route: 'dimension'
            }
        ]
    },
    // 成功案例块数据
    section3: {
        // 模块名称
        name: '成功案例',
        data: [
            {
                // 图片地址
                left_link: util.get_img('case_left.png'),
                right_link: util.get_img('case_right.png')
            },
            {
                // 图片地址
                left_link: util.get_img('case_left.png'),
                right_link: util.get_img('case_right.png')
            },
            {
                // 图片地址
                left_link: util.get_img('case_left.png'),
                right_link: util.get_img('case_right.png')
            },
            {
                // 图片地址
                left_link: util.get_img('case_left.png'),
                right_link: util.get_img('case_right.png')
            }
        ]
    },
    // 客户伙伴块数据
    section4: {
        // 模块名称
        name: '客户伙伴 信赖之选',
        data: [
            {
                // 图片地址
                link: util.get_img('index_customer_1.png'),
                // 描述
                description: '',
                // cta按钮文案
                cta: '了解详情'
            },
            {
                // 图片地址
                link: util.get_img('index_customer_2.png'),
                // 描述
                description: '',
                // cta按钮文案
                cta: '了解详情'
            },
            {
                // 图片地址
                link: util.get_img('index_customer_3.png'),
                // 描述
                description: '',
                // cta按钮文案
                cta: '了解详情'
            },
            {
                // 图片地址
                link: util.get_img('index_customer_4.png'),
                // 描述
                description: '',
                // cta按钮文案
                cta: '了解详情'
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/data/index.js